import { call, put, takeLatest } from "redux-saga/effects"

import ErrorsActions from "../../Redux/ErrorsRedux"
import { apiGeneratorBase } from "../../Utils/saga"
import Creators, { AlertsTypes as constants } from "./reducer"
import * as services from "./services"

const actions = {
  getAlertsStatisticsActions: {
    request: Creators.getAlertsStatisticsRequest,
    success: Creators.getAlertsStatisticsSuccess,
    errors: Creators.getAlertsStatisticsFailure
  },
  getAlertsFilterOptionsActions: {
    request: Creators.getAlertsFilterOptionsRequest,
    success: Creators.getAlertsFilterOptionsSuccess,
    errors: Creators.getAlertsFilterOptionsFailure
  },
  getAlertsActions: {
    request: Creators.getAlertsRequest,
    success: Creators.getAlertsSuccess,
    errors: Creators.alertsFailure
  },
  updateAlertActions: {
    request: Creators.updateAlertRequest,
    success: Creators.updateAlertSuccess,
    errors: Creators.alertsFailure
  },
  pinAlertActions: {
    request: Creators.pinAlertRequest,
    success: Creators.pinAlertSuccess,
    errors: Creators.alertsFailure
  },
  getAlertsOtherPageActions: {
    request: Creators.getAlertsOtherPageRequest,
    success: Creators.getAlertsOtherPageSuccess,
    errors: Creators.alertsFailure
  },
  getAlertsExportActions: {
    request: Creators.getAlertsExportRequest,
    success: Creators.getAlertsExportSuccess,
    errors: Creators.getAlertsExportFailure
    //downloadFile: true,
  },
  getAlertDetailsActions: {
    request: Creators.getAlertDetailsRequest,
    success: Creators.getAlertDetailsSuccess,
    errors: Creators.getAlertDetailsFailure
  },
  getAlertLogsActions: {
    request: Creators.getAlertLogsRequest,
    success: Creators.getAlertLogsSuccess,
    errors: Creators.getAlertLogsFailure
  },
  getAlertDetailsExportActions: {
    request: Creators.getAlertDetailsExportRequest,
    success: Creators.getAlertDetailsExportSuccess,
    errors: Creators.getAlertDetailsExportFailure,
    downloadFile: true
  },
  createAlertTicketActions: {
    request: Creators.createAlertTicketRequest,
    success: Creators.createAlertTicketSuccess,
    errors: Creators.createAlertTicketFailure
  },
  createCreditRequestActions: {
    request: Creators.createCreditRequestRequest,
    success: Creators.createCreditRequestSuccess,
    errors: Creators.createCreditRequestFailure
  },
  alertsBulkResolveActions: {
    request: Creators.alertsBulkResolveRequest,
    success: Creators.alertsBulkResolveSuccess,
    errors: Creators.alertsBulkResolveFailure,
    withoutErrorNotification: true
  }
}

const eventsOptions = {
  [constants.GET_ALERTS_STATISTICS_REQUEST]: {
    api: services.getAlertsStatistics,
    actions: actions.getAlertsStatisticsActions
  },
  [constants.GET_ALERTS_FILTER_OPTIONS_REQUEST]: {
    api: services.getAlertsFilterOptions,
    actions: actions.getAlertsFilterOptionsActions
  },
  [constants.GET_ALERTS_REQUEST]: {
    api: services.getAlerts,
    actions: actions.getAlertsActions
  },
  [constants.UPDATE_ALERT_REQUEST]: {
    api: services.updateAlert,
    actions: actions.updateAlertActions
  },
  [constants.PIN_ALERT_REQUEST]: {
    api: services.pinAlert,
    actions: actions.pinAlertActions
  },
  [constants.GET_ALERTS_OTHER_PAGE_REQUEST]: {
    api: services.getAlertsOtherPage,
    actions: actions.getAlertsOtherPageActions
  },
  [constants.GET_ALERTS_EXPORT_REQUEST]: {
    api: services.getAlertsExport,
    actions: actions.getAlertsExportActions
  },
  [constants.GET_ALERT_DETAILS_REQUEST]: {
    api: services.getAlertDetails,
    actions: actions.getAlertDetailsActions
  },
  [constants.GET_ALERT_LOGS_REQUEST]: {
    api: services.getAlertLogs,
    actions: actions.getAlertLogsActions
  },
  [constants.GET_ALERT_DETAILS_EXPORT_REQUEST]: {
    api: services.getAlertDetailsExport,
    actions: actions.getAlertDetailsExportActions
  },
  [constants.CREATE_ALERT_TICKET_REQUEST]: {
    api: services.createAlertTicket,
    actions: actions.createAlertTicketActions
  },
  [constants.CREATE_CREDIT_REQUEST_REQUEST]: {
    api: services.createCreditRequest,
    actions: actions.createCreditRequestActions
  },
  [constants.ALERTS_BULK_RESOLVE_REQUEST]: {
    api: services.alertsBulkResolve,
    actions: actions.alertsBulkResolveActions
  }
}

function* updateAlertFromDetailsPageSaga(action, provider) {
  const params = action.payload
  const alertId = params.alert_id
  const response = yield call(provider.api, params)
  if (response.ok) {
    yield put(provider.actions.success(response?.data))
    yield put(Creators.getAlertDetailsRequest(alertId))
    yield put(Creators.getAlertLogsRequest(alertId))
  } else {
    yield put(
      provider.actions.errors(
        response.data?.message?.detail || response.data?.message || response.data?.detail?.[0]
      )
    )
    const error = response.data
    yield put(ErrorsActions.errorSave(response.status === 500 ? "Server response error" : error))
  }
}

function* updateAlertTransactionSaga(action, provider) {
  const { refreshDetails, ...requestParams } = action.payload
  const alertId = requestParams.alert_id
  const response = yield call(provider.api, requestParams)

  if (response.ok) {
    yield put(Creators.updateAlertTransactionSuccess(response?.data))

    if (refreshDetails && alertId) {
      yield put(Creators.getAlertDetailsRequest(alertId))
      yield put(Creators.getAlertLogsRequest(alertId))
    }
  } else {
    const errorMessage =
      response?.data?.message?.detail ||
      response?.data?.message ||
      response?.data?.detail?.[0] ||
      "Server response error"

    yield put(Creators.updateAlertTransactionFailure(errorMessage))
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_ALERTS_STATISTICS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_ALERTS_STATISTICS_REQUEST])
  )
  yield takeLatest(constants.GET_ALERTS_FILTER_OPTIONS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_ALERTS_FILTER_OPTIONS_REQUEST])
  )
  yield takeLatest(constants.GET_ALERTS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_ALERTS_REQUEST])
  )
  yield takeLatest(constants.UPDATE_ALERT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.UPDATE_ALERT_REQUEST])
  )
  yield takeLatest(constants.PIN_ALERT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.PIN_ALERT_REQUEST])
  )
  yield takeLatest(constants.GET_ALERTS_EXPORT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_ALERTS_EXPORT_REQUEST])
  )
  yield takeLatest(constants.GET_ALERT_DETAILS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_ALERT_DETAILS_REQUEST])
  )
  yield takeLatest(constants.GET_ALERT_LOGS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_ALERT_LOGS_REQUEST])
  )
  yield takeLatest(constants.GET_ALERT_DETAILS_EXPORT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_ALERT_DETAILS_EXPORT_REQUEST])
  )
  yield takeLatest(constants.CREATE_ALERT_TICKET_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.CREATE_ALERT_TICKET_REQUEST])
  )
  yield takeLatest(constants.CREATE_CREDIT_REQUEST_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.CREATE_CREDIT_REQUEST_REQUEST])
  )
  yield takeLatest(constants.ALERTS_BULK_RESOLVE_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.ALERTS_BULK_RESOLVE_REQUEST])
  )
  yield takeLatest(constants.UPDATE_ALERT_FROM_DETAILS_PAGE, (action) =>
    updateAlertFromDetailsPageSaga(action, eventsOptions[constants.UPDATE_ALERT_REQUEST])
  )
  yield takeLatest(constants.UPDATE_ALERT_TRANSACTION_REQUEST, (action) =>
    updateAlertTransactionSaga(action, eventsOptions[constants.UPDATE_ALERT_REQUEST])
  )
}
